import { css } from "@emotion/react";
import {
  DelimiterStyleEnum,
  DelimiterPositionEnum,
} from "src/requests/templates/types";
import styled from "../../../../../../config/emotion";
import {
  BOLD,
  CENTER,
  LEFT,
  NORMAL,
  RIGHT,
} from "../../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";

const determineJustifyContent = (textAlign: string) => {
  switch (textAlign) {
    case LEFT:
      return "flex-start";
    case RIGHT:
      return "flex-end";
    case CENTER:
    default:
      return "center";
  }
};

const determineTextAlignment = (textAlign: string) => {
  switch (textAlign) {
    case LEFT:
      return "left";
    case RIGHT:
      return "right";
    case CENTER:
    default:
      return "center";
  }
};

export const determineFontWeight = (fontWeight: string) => {
  switch (fontWeight) {
    case BOLD:
      return BOLD;
    default:
      return NORMAL;
  }
};

export const Cell = styled.div<{ textAlign: string; fontWeight: string }>`
  display: flex;
  justify-content: ${({ textAlign }) => determineJustifyContent(textAlign)};

  text-align: ${({ textAlign }) => determineTextAlignment(textAlign)};

  font-weight: ${({ fontWeight }) => determineFontWeight(fontWeight)};

  white-space: normal !important;

  textarea {
    user-select: auto;
    -webkit-user-select: auto;

    text-align: justify;
    -mox-text-align-last: ${({ textAlign }) =>
      determineTextAlignment(textAlign)};
    text-align-last: ${({ textAlign }) => determineTextAlignment(textAlign)};
    width: 100%;
  }
`;

export const tableCssForMobileTableVariant = css`
  table-layout: fixed;
  width: 100%;
  margin: 2px 10px;

  @media (min-width: 1024px) {
    & > tr {
      display: flex;

      & > #empty-cell {
        height: 40px;
      }

      & > td {
        padding: 8px 12px;
      }
    }
  }
`;

export const getTableCssForDetailVariant = (
  colCount: number,
  screenWidthPx: number
) => {
  const minWidthPerColumnPx = 150;
  const CONTAINER_MARGIN_PX = 69;
  const minWidthPX = Math.min(
    colCount * minWidthPerColumnPx,
    screenWidthPx - CONTAINER_MARGIN_PX
  );

  return css`
    margin: 0;
    //Je nutný to nastavovat takto a ne přímo jako min width td, aby to fungovalo pro colspan
    table-layout: fixed;
    width: 100%;

    tr {
      & > #empty-cell {
        height: 30px;
      }

      & > td {
        padding: 2px 3px;
        & > div {
          width: 100%;
        }
      }
    }

    @media (min-width: 1024px) {
      tr {
        & > #empty-cell {
          height: 40px;
        }

        & > td {
          padding: 8px 12px;
        }
      }
    }
  `;
};

export const columnWidthCss = (tableWidth: number, colspan: number) => css`
  width: ${(100 / tableWidth) * colspan}%;
  position: relative;
`;

export const labelCellCss = css`
  white-space: nowrap;
`;

export const multipleLinesCss = css`
  white-space: pre-line;
`;

export const boldFontCss = css`
  font-weight: bold;
`;

const determineBorderPattern = (pattern: DelimiterStyleEnum): string => {
  switch (pattern) {
    case DelimiterStyleEnum.LINE:
      return "solid";
    case DelimiterStyleEnum.DOTTED_LINE:
      return "dotted";
    default:
      return "solid";
  }
};

const delimiterPositionSpecificCss = (
  pattern: DelimiterStyleEnum,
  position: DelimiterPositionEnum
) => {
  switch (position) {
    case DelimiterPositionEnum.HORIZONTAL:
      return css`
        top: 50%;
        left: 0;
        width: 100%;
        border-top: 3px ${determineBorderPattern(pattern)} lightgray;
        transform: translateY(-50%);
      `;
    case DelimiterPositionEnum.VERTICAL:
      return css`
        left: 50%;
        top: 0;
        height: 100%;
        width: 0 !important;
        border-left: 3px ${determineBorderPattern(pattern)} lightgray;
        transform: translateX(-50%);
      `;
    default:
      return "";
  }
};

export const delimiterContainerCss = (
  pattern: DelimiterStyleEnum,
  position: DelimiterPositionEnum
) => css`
  position: absolute;

  ${delimiterPositionSpecificCss(pattern, position)}
`;
